import { BASE_URL } from '../API/BASE_URL';

export const getBaners = async () => {
  const response = await fetch(BASE_URL + 'shops/banners/', {
    method: 'GET',
  });

  const data = await response.json();
  return data;
};
